import { createSelector } from 'reselect';

const getProductSales = state => state.productSales?.products;
const getProducts = state => state.products?.products;
const getBundles = state => state.bundleSales?.bundles;

export const hasDeliverableProducts = createSelector(
  [getProductSales, getBundles, getProducts],
  (productSales = [], bundles = [], products = {}) => {

    const hasDirect = Object.values(productSales || {}).some(productSale =>
      products?.[productSale.product_id]?.is_deliverable
    );

    if (hasDirect) {
      return true;
    }

    const hasBundle = bundles.some(bundle => {
      const bundleProducts = bundle?.contents?.products || {};

      return Object.keys(bundleProducts).some(productId =>
        products?.[productId]?.is_deliverable
      );
    });

    return hasBundle;
  }
);